import React from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { useSelector } from '@shared/store';
import { MBSendButton } from '../components/sendButton';

interface OwnProps {
  draftId: string;
  style?: StyleProp<ViewStyle>;
  onPress(): void;
  testID?: string;
}

export function MBChatInputSendButton({ draftId, style, onPress, testID }: OwnProps) {
  const urgent = useSelector(state => !!state.chatInput.urgentFromDraftId[draftId]);
  return <MBSendButton urgent={urgent} style={style} onPress={onPress} testID={testID} />;
}
